import { render, staticRenderFns } from "./OBSControl.vue?vue&type=template&id=4ee2ea73&scoped=true&"
import script from "./OBSControl.vue?vue&type=script&lang=js&"
export * from "./OBSControl.vue?vue&type=script&lang=js&"
import style0 from "./OBSControl.vue?vue&type=style&index=0&id=4ee2ea73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2ea73",
  null
  
)

export default component.exports